module.exports = __webpack_public_path__ + "static/media/Hydra.fec95a33.jpg";